module.exports = __webpack_public_path__ + "img/f3ee5fb.jpg";